import { useMemo, useState } from 'react';

import dayjs from 'dayjs';
import { useFinanceContext } from 'src/components/plaid/datasource';

const useShortcutItems = () => {
  const { keyAssumptions } = useFinanceContext();
  const retirementAge = keyAssumptions?.targetRetirementAge ?? 90; // Default to 90 if not available
  const [shortcutItem, setShortcutItem] = useState(null);

  const shortcutsItems = useMemo(
    () => [
      {
        primary: 'This Year',
        detail: 'Year-to-Date',
        icon: 'mdi:calendar',
        getValue: () => {
          const today = dayjs();
          return [today.startOf('year'), today.endOf('year')].map((e) => e.toDate());
        },
      },
      {
        primary: '±2 Years',
        detail: 'Past & Next 2 Years',
        icon: 'mdi:calendar-range',
        getValue: () => {
          const today = dayjs();
          return [
            today.subtract(2, 'year').startOf('year'),
            today.add(2, 'year').endOf('year'),
          ].map((e) => e.toDate());
        },
      },
      {
        primary: '+10 Years',
        detail: 'Mid-Term Goals',
        icon: 'mdi:calendar-multiple',
        getValue: () => {
          const today = dayjs();
          return [today.startOf('year'), today.add(10, 'year').endOf('year')].map((e) =>
            e.toDate()
          );
        },
      },
      {
        primary: '+30 Years',
        detail: 'Long-Term Planning',
        icon: 'mdi:calendar-month',
        getValue: () => {
          const today = dayjs();
          return [today.startOf('year'), today.add(30, 'year').endOf('year')].map((e) =>
            e.toDate()
          );
        },
      },
      {
        primary: 'Retirement',
        detail: 'To Retirement Age',
        icon: 'mdi:calendar-clock',
        getValue: () => {
          const today = dayjs();
          return [today.startOf('year'), today.add(retirementAge, 'year').endOf('year')].map((e) =>
            e.toDate()
          );
        },
      },
    ],
    [retirementAge]
  );

  return { shortcutsItems, shortcutItem, setShortcutItem };
};

export default useShortcutItems;
